var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 15.6373L15.3 13.732C16.6333 12.9622 16.6333 11.0377 15.3 10.2679L11.9999 8.36267C10.6666 7.59287 8.99994 8.55512 8.99994 10.0947L8.99994 13.9053C8.99994 15.4449 10.6666 16.4071 11.9999 15.6373ZM14.4 11.8268C14.5333 11.9038 14.5333 12.0962 14.4 12.1732L11.0999 14.0785C10.9666 14.1555 10.7999 14.0592 10.7999 13.9053V10.0947C10.7999 9.94076 10.9666 9.84453 11.0999 9.92152L14.4 11.8268Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99962 4.99962C6.79018 3.20906 9.26641 2.09998 12 2.09998C14.7335 2.09998 17.2098 3.20906 19.0003 4.99962C20.7909 6.79018 21.9 9.26641 21.9 12C21.9 14.7335 20.7909 17.2098 19.0003 19.0003C17.2098 20.7909 14.7335 21.9 12 21.9C9.26641 21.9 6.79018 20.7909 4.99962 19.0003C3.20906 17.2098 2.09998 14.7335 2.09998 12C2.09998 9.26641 3.20906 6.79018 4.99962 4.99962ZM12 3.89998C9.76297 3.89998 7.73921 4.80561 6.27241 6.27241C4.80561 7.73921 3.89998 9.76297 3.89998 12C3.89998 14.237 4.80561 16.2607 6.27241 17.7275C7.73921 19.1943 9.76297 20.1 12 20.1C14.237 20.1 16.2607 19.1943 17.7275 17.7275C19.1943 16.2607 20.1 14.237 20.1 12C20.1 9.76297 19.1943 7.73921 17.7275 6.27241C16.2607 4.80561 14.237 3.89998 12 3.89998Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCircleOutline);
export default __webpack_public_path__ + "static/media/video_circle_outline.75bb14f5c688349b3f40e60832d4254c.svg";
export { ForwardRef as ReactComponent };